export const WHATSAPP_NUMBER = "628174826622";

export const CONTACT = {
  alamat: "Tojan, Pering, Blahbatuh, Gianyar - Bali",
  whatsapp: "+62 817-482-6622",
  email: "halo@ascaryadekorasi.com",
  instagram: "@ascaryadekorasi",
  jam: "Senin - Minggu: 08.00 - 20.00 WIB",
};

export const BANKS = [
  { bank: "Bank BRI", account: "024801012335536", holder: "I Gusti Ngurah Adek Saputra" },
  { bank: "Bank Mandiri", account: "1450014100354", holder: "I Gusti Ngurah Adek Saputra" },
];

export const QRIS_URL =
  "https://api.qrserver.com/v1/create-qr-code/?size=280x280&data=00020101021126580014ID.GO.QRIS.WWW0118936009140000000000021ID10200000000000303UMI5204599953033605802ID5915ASCARYA%20DEKOR6007JAKARTA6105121106304ASCY";

export const PACKAGES = [
  {
    id: "basic",
    name: "Paket Sahaja (Basic)",
    tagline: "Minimalis Elegan untuk Acara Intimate",
    price: 8500000,
    photo:
      "https://images.unsplash.com/photo-1747115276395-607f2e5dc269?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHx3ZWRkaW5nJTIwZmxvcmFsJTIwYXJjaCUyMHNldHVwJTIwZ29sZCUyMHdhcm0lMjB0aGVtZXxlbnwwfHx8fDE3OTA1NTYzNjR8MA&ixlib=rb-4.1.0&q=85",
    description:
      "Paket dekorasi minimalis nan elegan, sempurna untuk acara akad atau resepsi intimate dengan sentuhan bunga fresh pilihan.",
    features: [
      "Backdrop Pelaminan Minimalis 4 Meter",
      "Bunga Fresh Accent + Artificial Premium",
      "Lighting Standard Studio Warm White",
      "Meja Akad / Penerima Tamu Simple Set",
      "Karpet Jalan Premium 10m",
    ],
  },
  {
    id: "elegant",
    name: "Paket Elegansi (Elegant)",
    tagline: "Sentuhan Kemewahan untuk Resepsi Menengah",
    price: 15000000,
    photo:
      "https://images.unsplash.com/photo-1785339678169-9b19ecb4c443?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHw0fHx3ZWRkaW5nJTIwdGFibGUlMjBkZWNvcmF0aW9uJTIwZmxvd2VycyUyMGx1eHVyeXxlbnwwfHx8fDE3OTA1NTYzNjR8MA&ixlib=rb-4.1.0&q=85",
    description:
      "Dekorasi penuh kemewahan dengan full fresh flower dan photo booth custom, ideal untuk resepsi skala menengah.",
    features: [
      "Backdrop Pelaminan Lux 6-8 Meter",
      "Full Fresh Flower Arrangements",
      "Gate / Floral Arch Entrance Utama",
      "Photo Booth Corner Custom Theme",
      "Lighting Architectural Warm Gold",
      "Set Meja Akad & Kursi Futura Decor",
    ],
  },
  {
    id: "premium",
    name: "Paket Megah Ascarya (Premium)",
    tagline: "Dekorasi Grand Ballroom & Resepsi Skala Besar",
    price: 28000000,
    photo:
      "https://images.unsplash.com/photo-1786125493218-f9933f67a0f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHxfYXJjaHxlbnwwfHx8fDE3OTA1NTYzNTZ8MA&ixlib=rb-4.1.0&q=85",
    description:
      "Dekorasi megah untuk grand ballroom dengan stage custom, standing flowers, dan sistem lighting profesional lengkap.",
    features: [
      "Stage Pelaminan Megah 10-12 Meter Custom",
      "100% Fresh Import & Local High Grade Flowers",
      "Aisle Standing Flowers + Tunnel/Arch Walkway",
      "Photo Booth 3D Backdrop + Ring Light",
      "Full Lighting Ambient & Spotlights System",
      "Dekorasi Meja VVIP & Buffet Area",
      "Desain 3D Layout Preview Gratis",
    ],
  },
  {
    id: "custom",
    name: "Paket Impian Custom",
    tagline: "Konsep Khusus Sesuai Imajinasi Klien",
    price: 35000000,
    photo:
      "https://images.unsplash.com/photo-1763553113391-a659bee36e06?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwzfHx3ZWRkaW5nJTIwdGFibGUlMjBkZWNvcmF0aW9uJTIwZmxvd2VycyUyMGx1eHVyeXxlbnwwfHx8fDE3OTA1NTYzNjR8MA&ixlib=rb-4.1.0&q=85",
    description:
      "Wujudkan konsep dekorasi impian tanpa batas, mulai dari tema tradisional hingga European garden, dirancang khusus untuk Anda.",
    features: [
      "Bebas Pilih Tema (Jawa, Sunda, Modern, Rustic, European)",
      "Konsultasi Personal dengan Master Florist",
      "3D Concept Rendering & Moodboard Iterative",
      "Unlimited Lighting & Visual Atmosphere FX",
      "Dedicated On-site Event Decor Supervisor",
    ],
  },
];

export const GALLERY = [
  {
    id: "g1",
    category: "Pelaminan",
    title: "Pelaminan Royal Gold & Ivory",
    image:
      "https://images.unsplash.com/photo-1786125493218-f9933f67a0f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHxfYXJjaHxlbnwwfHx8fDE3OTA1NTYzNTZ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "g2",
    category: "Aisle & Arch",
    title: "Outdoor Romantic Floral Arch",
    image:
      "https://images.unsplash.com/photo-1747115276395-607f2e5dc269?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHx3ZWRkaW5nJTIwZmxvcmFsJTIwYXJjaCUyMHNldHVwJTIwZ29sZCUyMHdhcm0lMjB0aGVtZXxlbnwwfHx8fDE3OTA1NTYzNjR8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "g3",
    category: "Meja VVIP",
    title: "Luxury Candlelight Dinner Table",
    image:
      "https://images.unsplash.com/photo-1785339678169-9b19ecb4c443?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHw0fHx3ZWRkaW5nJTIwdGFibGUlMjBkZWNvcmF0aW9uJTIwZmxvd2VycyUyMGx1eHVyeXxlbnwwfHx8fDE3OTA1NTYzNjR8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "g4",
    category: "Photo Booth",
    title: "Rustic Warm Garden Corner",
    image:
      "https://images.unsplash.com/photo-1763553113391-a659bee36e06?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwzfHx3ZWRkaW5nJTIwdGFibGUlMjBkZWNvcmF0aW9uJTIwZmxvd2VycyUyMGx1eHVyeXxlbnwwfHx8fDE3OTA1NTYzNjR8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const EVENT_TYPES = [
  "Pernikahan (Wedding Reception)",
  "Akad Nikah / Pemberkatan",
  "Lamaran / Engagement",
  "Birthday Party / Anniversary",
  "Corporate / Gala Event",
];

export const GUEST_OPTIONS = [
  "Intimate (< 100 Tamu)",
  "Medium (100 - 300 Tamu)",
  "Large (300 - 700 Tamu)",
  "Grand (> 700 Tamu)",
];

export const formatRupiah = (n) =>
  "Rp " + Number(n || 0).toLocaleString("id-ID");
